function equalizeHeight(asp) {
    $("div.productPreviewBox").each(function () {
        var prev = $(this).prev();
        if (prev !== undefined) {
            var thisPosTop = $(this).position().top;
            var prevPosTop = prev.position().top;

            if (thisPosTop === prevPosTop) {
                var thisHeight = $(this).height();
                var prevHeight = prev.height();

                //console.log("this " + thisHeight);
                //console.log("prev " + prevHeight);

                if (thisHeight < prevHeight) {
                    $(this).height(prevHeight);
                    prev.height(prevHeight);
                }
                else {
                    $(this).height(thisHeight);
                    prev.height(thisHeight);
                }
            }
        }
    });
}